import { ClaudeLogo } from '@/components/BrandAvatar';

const TypingDots = () => (
  <div className="chat-row chat-row--typing">
    <div className="claude-avatar-small" aria-hidden="true">{ClaudeLogo}</div>
    <div className="typing-dots" aria-label="Claude is typing">
      <span /><span /><span />
    </div>
  </div>
);

export default TypingDots;
